import classNames from 'classnames';
import React from 'react';

import {Button, IconButton, Text} from '@albert-io/atomic';
import {useStudentHomepageStore} from './useStudentHomepageStore';
import ClassroomFlair from './ClassroomFlair';

interface Props extends PropsWithClassNameOptional {
  classroomId: string | undefined;
}

export default function Header({className, classroomId}: Props) {
  const classrooms = useStudentHomepageStore((state) => state.classrooms);
  const isSidebarExpanded = useStudentHomepageStore((state) => state.isSidebarExpanded);
  const setIsSidebarExpanded = useStudentHomepageStore((state) => state.setIsSidebarExpanded);
  const setShowJoinClassModal = useStudentHomepageStore((state) => state.setShowJoinClassModal);

  const currentClassroom = classrooms.find((classroom) => classroom.getId() === classroomId);
  const isHome = !currentClassroom;
  const currentClassroomName = currentClassroom?.getName() ?? 'Home';

  return (
    <div
      className={classNames(
        'flex shrink-0 items-center overflow-x-hidden px-x1 pt-x3 s:px-x3',
        className
      )}
    >
      <IconButton
        className='mr-x1'
        icon='bars'
        label='Toggle sidebar button'
        onClick={() => {
          setIsSidebarExpanded(!isSidebarExpanded);
        }}
      />
      <ClassroomFlair isForAll={isHome} classroom={currentClassroom} />
      <Text className='mr-x2 flex-1 truncate font-black' size='xl'>
        {currentClassroomName}
      </Text>
      <Button
        className='shrink-0'
        data-testid='join-class-button'
        onClick={() => {
          setShowJoinClassModal(true);
        }}
        roundness='pill'
      >
        Join Class
      </Button>
    </div>
  );
}
